import React from "react";
import DestinationData from "./DestinationData";
import FriggaHomePagePic from "../assets/homepagephotos/friggahomepageimage.png";

const Destination = () => {
  return (
    <>
      <div className="destination">
        <p>
          Frigga Consulting Group LLC is a specialized compliance and strategic advisory firm
          serving the defense industry, aerospace companies, and technology enterprises
          operating in regulated international markets. We provide the expert guidance
          organizations need to move decisively without crossing lines that carry existential
          consequences.
        </p>
        {/* <DestinationData
          className="first-des"
          heading="Frigga Consulting Group"
          text="Our work bridges strategy, security, and financial diplomacy, promoting integrity and resilience in a complex global environment."
          img={FriggaWebsitePagePic}
        /> */}

        <DestinationData
          className="first-des-reverse"
          heading="Mission Statement"
          text="To protect and advance the global interests of our clients by delivering precise,
                actionable compliance advisory on economic sanctions, CFIUS regulations, and
                foreign investment risk — ensuring that every cross-border decision is made
                from a position of legal clarity, strategic confidence, and institutional integrity."
          img={FriggaHomePagePic}
        />
        {/* <p>
          Connect on LinkedIn:{" "}
          <a
            href="https://www.linkedin.com/in/susan-heidenreich-mba-45b73364/"
            target="_blank"
            rel="noreferrer"
          >
            Susan Heidenreich
          </a>
        </p> */}
      </div>
    </>
  );
};

export default Destination;
